<script setup lang="ts">
const { updateAvailable, refresh, dismiss } = useVersionCheck()
</script>

<template>
  <Teleport to="body">
    <Transition name="fade">
      <div
        v-if="updateAvailable"
        class="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 backdrop-blur-[2px]"
      >
        <div class="bg-white rounded-2xl shadow-2xl max-w-sm w-full mx-4 p-6">
          <div class="flex items-center gap-3 mb-4">
            <div class="w-10 h-10 rounded-full bg-brand-light flex items-center justify-center">
              <Icon name="heroicons:arrow-path" class="w-5 h-5 text-[#26250F]" />
            </div>
            <h2 class="text-lg font-bold text-gray-900">Atualização disponível</h2>
          </div>

          <p class="text-sm text-gray-600 mb-6">
            Uma nova versão do sistema está disponível. Atualize para ter acesso às melhorias mais recentes.
          </p>

          <div class="flex gap-3">
            <button
              @click="dismiss"
              class="flex-1 px-4 py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Agora não
            </button>
            <button
              @click="refresh"
              class="flex-1 px-4 py-2.5 text-sm font-medium text-white bg-[#26250F] rounded-lg hover:bg-[#1E1D0B] transition-colors"
            >
              Atualizar
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
